import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CaretUpIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "caret-up",
  "CaretUpIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M8 4.66663L12 11L4 11L8 4.66663Z" fill={colorList[0]} fillOpacity="0.9"/></g></svg>
);

export default CaretUpIcon;
